export const printShopHandler = {
    pathPattern: '/brands/:brandId/marketing/print-shop',
    toWeb: ({ brandId }) => ({
        path: `/brands/${brandId}/marketing/print-shop`,
    }),
    meta: {
        title: 'Print shop order',
        description: 'Opens a print-shop order in the marketing dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'orderId', in: 'query', required: false },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            query: { orderId: 'exampleOrderId' },
        },
    },
};
//# sourceMappingURL=print-shop.js.map